import { useCallback, useEffect, useRef, useState } from "react";

const OPEN_DELAY = 300;
const CLOSE_DELAY = 150;

export const useHoverPopover = () => {
	const [open, setOpen] = useState(false);
	const timer = useRef<ReturnType<typeof setTimeout>>(null);

	const cancel = useCallback(() => {
		if (timer.current) clearTimeout(timer.current);
	}, []);

	const schedule = useCallback(
		(next: boolean, delay: number) => {
			cancel();
			timer.current = setTimeout(() => setOpen(next), delay);
		},
		[cancel],
	);

	useEffect(() => cancel, [cancel]);

	const close = useCallback(() => {
		cancel();
		setOpen(false);
	}, [cancel]);

	return {
		open,
		setOpen,
		close,
		triggerProps: {
			onMouseEnter: () => schedule(true, OPEN_DELAY),
			onMouseLeave: () => schedule(false, CLOSE_DELAY),
		},
		// The popover is portaled: moving onto it leaves the line, so the close must be cancelled.
		contentProps: {
			onMouseEnter: cancel,
			onMouseLeave: () => schedule(false, CLOSE_DELAY),
		},
	};
};
